import { isEmpty } from 'lodash';
import fetchApi from 'services/fetch';
import { boAPI } from 'constants/api';
import { removeWhiteSpace, replaceSpecialChars } from 'utils/utils';
import {
  track,
  generateServerResponseError,
  generateMessageDisplayedSegment,
  updateGlobalTracker,
} from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const getProductDetails = (pkg) => {
  const {
    commercialEnrichmentsList = [],
    pricesList = [],
    negocioSegmento,
    productOfferingUUID,
    sucursalId,
    cicloID,
    negocioSegmentotipoID,
    ch_Ocid,
    bonificacion,
    includedItemsList = [],
    installationCost,
  } = pkg;
  const details = {
    name: '',
    description: '',
    price: 0,
    priority: '',
    title: '',
    sucursalId,
    cicloID,
    negocioSegmento,
    negocioSegmentotipoID,
    ch_Ocid,
    productOfferingUUID,
    bonificacion,
    installationCost: installationCost || 0,
  };
  commercialEnrichmentsList.forEach((element) => {
    details.name = element.descriptions?.entries?.find((entry) => entry.key === 'name')?.value;
    details.description =
      element.descriptions?.entries?.find((entry) => entry.key === 'long-description')?.value || 'Otro';
    details.price = pricesList?.[0]?.price?.taxIncludedAmount;
  });

  const title = includedItemsList?.[0]?.commercialEnrichmentsList?.[0]?.description?.entries?.find(
    (entry) => entry.key === 'type'
  )?.value;
  return { ...details, title };
};

const processPrice = (pkg, familyName, commercialEnrichment) => {
  const price =
    pkg?.pricesList[0]?.discountsList[0]?.amount > 0
      ? Number(pkg?.pricesList[0]?.discountsList[0].amount)
      : Number(pkg?.pricesList[0]?.price?.taxIncludedAmount);
  if (familyName === 'Decoder Adicional') {
    const quantity = Number(commercialEnrichment?.description?.entries?.find((entry) => entry.key === 'detail').value);
    return { price: 0, quantity, defaultQty: quantity };
  } else {
    return { price };
  }
};

const getAdditionalDetails = (pkg) => {
  const additionalDetail = [];
  const { includedItemsList = [] } = pkg;
  includedItemsList.map((IncludedItem) => {
    const { commercialEnrichmentsList = [] } = IncludedItem;
    commercialEnrichmentsList.forEach((element) => {
      additionalDetail.push({
        type: element.description?.entries?.find((entry) => entry.key === 'type')?.value,
        name: element.description?.entries?.find((entry) => entry.key === 'name')?.value,
        description: element.description?.entries?.find((entry) => entry.key === 'long-description')?.value,
      });
    });
  });
  return additionalDetail;
};

const getAddons = (pkg) => {
  const addons = [];
  const addonItemsList = pkg?.includedItemsList || [];
  addonItemsList.forEach((IncludedItem) => {
    const allowancesItems = IncludedItem?.allowancesList || [];
    const promotionID = IncludedItem?.promotionID || '0';
    allowancesItems.forEach((allowancesItem) => {
      const { commercialEnrichmentsList = [] } = allowancesItem;
      commercialEnrichmentsList.forEach((commercialEnrichment) => {
        const familyName = commercialEnrichment?.description?.entries?.find(
          (entry) => entry.key === 'familyName'
        ).value;
        const addonItem = {
          taxIncludedAmount: allowancesItem?.pricesList[0]?.price?.taxIncludedAmount,
          name: commercialEnrichment?.description?.entries?.find((entry) => entry.key === 'name')?.value,
          promo: allowancesItem?.pricesList[0]?.discountsList[0].commercialEnrichmentsList[0].description.entries?.find(
            (entry) => entry.key === 'promotion-description'
          )?.value,
          description: commercialEnrichment?.description?.entries?.find((entry) => entry.key === 'long-description')
            ?.value,
          id: allowancesItem.productOfferingUUID,
          prepagoID: allowancesItem.prepagoID,
          politicaID: allowancesItem.politicaID,
          promotionID: allowancesItem?.promotionID || promotionID,
          productOfferingUUID: allowancesItem.productOfferingUUID,
          familyName,
          discountAmount: allowancesItem?.pricesList[0]?.discountsList[0].amount,
          isAllowanceItem: true,
          ...processPrice(allowancesItem, familyName, commercialEnrichment),
        };
        addons.push(addonItem);
      });
    });
  });
  return addons;
};

const getBundledItems = ({ includedItemsList = [] }) => {
  const items = [];
  includedItemsList.forEach(({ bundledItemsList = [] }) => {
    bundledItemsList.forEach((bundledItem) => {
      const { commercialEnrichmentsList = [] } = bundledItem;
      let addonItem = {
        taxIncludedAmount: bundledItem?.pricesList[0]?.price?.taxIncludedAmount,
        id: bundledItem.id,
        prepagoID: bundledItem.prepagoID || '0',
        politicaID: bundledItem.politicaID || '0',
        promotionID: bundledItem?.promotionID || '0',
        productOfferingUUID: bundledItem.id,
        price: Number(bundledItem?.pricesList?.[0]?.price?.taxIncludedAmount || '0'),
      };
      if (commercialEnrichmentsList.length) {
        const x = commercialEnrichmentsList[0];
        addonItem['name'] = x?.description?.entries?.find((entry) => entry.key === 'name')?.value;
        addonItem['description'] = x?.description?.entries?.find((entry) => entry.key === 'long-description')?.value;
      }
      items.push(addonItem);
    });
  });
  return items;
};

const getIncludedItems = ({ includedItemsList = [] }) => {
  const items = [];
  includedItemsList.forEach((includedItem) => {
    const { commercialEnrichmentsList = [] } = includedItem;
    let addonItem = {
      taxIncludedAmount: includedItem?.pricesList[0]?.price?.taxIncludedAmount,
      id: includedItem.id,
      prepagoID: includedItem.prepagoID || '0',
      politicaID: includedItem.politicaID || '0',
      promotionID: includedItem?.promotionID || '0',
      productOfferingUUID: includedItem.id,
      price: Number(includedItem?.pricesList?.[0]?.price?.taxIncludedAmount || '0'),
    };
    if (commercialEnrichmentsList.length) {
      const x = commercialEnrichmentsList[0];
      addonItem['name'] = x?.description?.entries?.find((entry) => entry.key === 'name')?.value;
      addonItem['description'] = x?.description?.entries?.find((entry) => entry.key === 'long-description')?.value;
    }
    items.push(addonItem);
  });
  return items;
};

const getMainProdInfo = (selectedPack, state, addon) => {
  console.log('getMainProdInfo::state', state);
  let inputtedCharacteristics = [
    {
      key: 'CH_cicloId',
      value: selectedPack.cicloID,
    },
    {
      key: 'CH_preventaSucursalId',
      value: selectedPack.sucursalId,
    },
    {
      key: 'CH_edificioNro',
      value: state?.['inputAddress']?.['location']?.['buildingId']?.['mainBuildingId'] || '0',
    },
    {
      key: 'CH_negocioSegmentoTipoId',
      value: selectedPack.negocioSegmentotipoID,
    },
    {
      key: 'CH_negocioSegmento',
      value: selectedPack.negocioSegmento,
    },
    {
      key: 'CH_clienteTpo',
      value: '2',
    },
    {
      key: 'CH_cantv',
      // value: addon?.familyName === 'Decoder Adicional' ? `${addon.quantity}` : '1',
      // value: '0',
      value: 1 + state?.packages?.additionalTVs,
    },
    {
      key: 'CH_OcId',
      value: selectedPack.ch_Ocid,
    },
    {
      key: 'CH_preventaPropiedad',
      value: 'P',
    },
  ];
  return {
    basketProducts: {
      attributes: {
        inputtedCharacteristics,
      },
      relationships: {
        productOfferingId: selectedPack.productOfferingUUID,
      },
    },
  };
};

const getUpdateParams = ({ selectedPack, state }) => {
  const allProductDetails = [];

  const selectedAddons = selectedPack.addOns.filter((addOn) => addOn?.selected);

  [...selectedPack.bundledItems, ...selectedPack.includedItems, ...selectedAddons].forEach((addOn) => {
    const productObj = {
      included: {
        newInstance: {
          attributes: {
            action: 'Add',
            quantity: 1,
          },

          included: {
            basketEntity: getMainProdInfo(selectedPack, state, addOn),
            childBasketItems: [
              {
                attributes: {
                  action: 'Add',
                  quantity: 1,
                },
                included: {
                  basketEntity: {
                    basketProducts: {
                      attributes: {
                        inputtedCharacteristics: getInputCharacteristics(addOn),
                      },
                      relationships: {
                        productOfferingId: addOn?.id || '',
                      },
                    },
                  },
                },
              },
            ],
          },
        },
      },
    };
    allProductDetails.push(productObj);
  });

  if (selectedPack.bonificacion && selectedPack.bonificacion !== '') {
    allProductDetails.push({
      included: {
        newInstance: {
          attributes: {
            action: 'Add',
            quantity: 1,
          },

          included: {
            basketEntity: getMainProdInfo(selectedPack, state),
            childBasketItems: [
              {
                attributes: null,
                included: {
                  basketEntity: {
                    basketProducts: {
                      attributes: {
                        inputtedCharacteristics: [
                          {
                            key: 'CH_MSISDN',
                            value: removeWhiteSpace(replaceSpecialChars(state.packages.minutosPhone.cliTelephone)),
                          },
                          {
                            key: 'CH_PLAN',
                            value: '***',
                          },
                          {
                            key: 'CH_clientetelObs',
                            value: 'Beneficiario HomeStore',
                          },
                          {
                            key: 'CH_clienteTelTpo',
                            value: '8',
                          },
                          {
                            key: 'CH_bonificado',
                            value: 'SI',
                          },
                          {
                            key: 'CH_convergente',
                            value: 'NO',
                          },
                        ],
                      },
                      relationships: {
                        productOfferingId: 'PO_BonificacionConvergente',
                      },
                    },
                  },
                },
              },
            ],
          },
        },
      },
    });
  }

  return {
    activateService: {
      createBasketAndAddItemsMutation: {
        basketCreateMutation: {
          included: {
            newInstance: {
              attributes: {
                referenceNumber: '3',
                salesContext: {
                  channel: '101',
                  chainId: '',
                  dealerId: '',
                  salespersonId: '39864',
                  batchId: '',
                  salesType: '',
                  salesGroup: '4',
                },
              },
              relationships: {},
            },
          },
        },
        addBasketItemsMutation: allProductDetails,
        basketPaymentMutation: {
          included: {
            newInstance: {
              attributes: {
                amount: {
                  amount: 0,
                  currency: 'BOB',
                },
                createdAt: new Date().toISOString(),
                paymentMethod: {
                  genericPaymentMethod: {
                    paymentType: 'cash',
                  },
                },
              },
            },
          },
        },
      },
    },
    leadStep: '3',
  };
};

const getInputCharacteristics = (selectedPack) => {
  let characterArray = [
    {
      key: 'CH_prepagoId',
      value: selectedPack.prepagoID,
    },
    {
      key: 'CH_promocionId',
      value: selectedPack.promotionID,
    },
    {
      key: 'CH_politicaId',
      value: selectedPack.politicaID,
    },
  ];
  if (selectedPack?.isAllowanceItem) {
    characterArray.push({
      key: 'typeProd',
      value: 'addons',
    });
  }
  return characterArray;
};

const initialState = {
  packages: [],
  currentSelected: [],
  selectedCategory: '',
  minutosPhone: '',
  additionalTVs: 0,
};

export const packages = {
  state: { ...initialState },
  reducers: {
    saveSelection(state, { product = {}, type = '' }) {
      let offerList;
      if (!isEmpty(product)) {
        if (type === 'package') {
          const filterData = state.currentSelected.find((selected) => selected.id === product.id);
          if (filterData) {
            offerList = [];
          } else {
            offerList = [product];
          }
        } else {
          offerList = JSON.parse(JSON.stringify(state.currentSelected));
          offerList[0].addOns.map((x) => {
            if (x.id === product.id) {
              x['selected'] = !x['selected'];
            }
          });
        }
        return { ...state, currentSelected: offerList };
      }
      return { ...state };
    },
    setSelectedCategory(state, payload) {
      return { ...state, selectedCategory: payload };
    },
    updatePackageList(state, payload) {
      return { ...state, packages: payload };
    },
    updateSelected(state, payload) {
      return { ...state, currentSelected: payload };
    },
    updateQuantity(state, { data, quantity }) {
      const currentSelected = state.currentSelected;
      currentSelected[0].addOns.map((addOn) => {
        if (addOn.id === data.id) {
          addOn.quantity = Number(quantity);
          if (Number(quantity) > addOn.defaultQty) {
            addOn.price = (quantity - addOn.defaultQty) * addOn.taxIncludedAmount;
          } else {
            addOn.price = 0;
          }
        }
      });
      return { ...state, currentSelected };
    },
    updateAdditionalTVs(state, { quantity }) {
      return { ...state, additionalTVs: quantity };
    },
    clearPackages() {
      return {
        ...initialState,
      };
    },
    updateMinutos(state, payload) {
      return { ...state, minutosPhone: payload };
    },
  },
  effects: (dispatch) => {
    return {
      async getPackages(params, state) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'get',
          url: `${boAPI.packages}/${params?.node || state?.locationDetails?.coverage?.nodeid}`,
        })
          .then((response) => {
            const { productOfferingsList } = response.data;

            const packageList = productOfferingsList?.map((product) => {
              const offerId = product.productOfferingUUID || Math.random();
              return {
                id: offerId,
                ...getProductDetails(product),
                characteristics: getAdditionalDetails(product),
                offerType: 'packages',
                addOns: getAddons(product),
                bundledItems: getBundledItems(product),
                includedItems: getIncludedItems(product),
              };
            });
            dispatch.packages.updatePackageList(packageList);

            updateGlobalTracker({
              products: packageList?.map((product) => {
                return {
                  product_id: product.id,
                  category: 'combo',
                  name: product.name,
                  variant: 'bundle',
                  price: product.price,
                  quantity: product.quantity || 1,
                };
              }),
            });

            if (params?.lead) {
              this.formatPackage({ packageList, lead: params.lead?.productOfferingsList });
            }
            dispatch.apiStatus.setProcessing(false);
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Get Services',
                `${boAPI.packages}/${params?.node || state?.locationDetails?.coverage?.nodeid}`,
                'Get Services API'
              ),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Services API') });
          });
      },

      async updateOffers(params, state) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'PATCH',
          url: boAPI.updateLead.replace(':id', state?.activation?.basket?.response?.id),
          data: { ...getUpdateParams({ selectedPack: params, state }) },
        })
          .then((res) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true });
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Update basket',
                boAPI.updateLead.replace(':id', state?.activation?.basket?.response?.id),
                'Update basket API'
              ),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Update basket API') });
            return Promise.resolve({ success: false });
          });
      },
      formatPackage(data) {
        const mainId = data?.lead?.[0]?.productOfferingUUID;
        const selected = data?.packageList?.find((x) => Number(x.productOfferingUUID) === Number(mainId)) || {};
        const addons = data?.lead
          ?.filter((x) =>
            x.childBasketItems?.[0]?.commercialEnrichmentsList?.names?.entries?.find((y) => y.key === 'typeProd')
          )
          ?.reduce((acc, cur) => {
            return [
              ...acc,
              { id: cur?.childBasketItems?.[0]?.productOfferingUUID, quantity: cur?.childBasketItems?.[0]?.quantity },
            ];
          }, []);

        const list =
          selected?.addOns?.map((x) => {
            const addon = addons?.find((y) => y.id === x.productOfferingUUID);
            if (addon) {
              return { ...x, selected: true, quantity: addon.quantity };
            }
            return x;
          }) || [];

        const getList = (prodLists, type) => {
          return prodLists?.map((product) => {
            return {
              product_id: product.productOfferingUUID,
              category: 'combo',
              name: product['name'],
              variant: type,
              price: product.price,
              quantity: product.quantity || 1,
            };
          });
        };

        updateGlobalTracker({
          products: [...getList([selected], 'buntle'), ...getList([...list], 'addon')],
        });

        this.updateSelected([{ ...selected, addOns: list }]);
      },
    };
  },
};
